export const socialConfig = JSON.parse(document.getElementById('social-config').textContent);
